<template>
  <div>
    <!-- HEADER (same pattern as visit list) -->
    <!-- <header class="visit-header">
                <div class="brand-mark">
                    <q-btn flat dense rounded @click="showDrawer">
                        <q-icon name="menu" :size="$q.screen.lt.md ? '40px' : '28px'" />
                    </q-btn>
                </div>

                <div class="header-content">
                    <img class="brand-logo-sera" src="../assets/SERA_LOGO.png" />
                    <h1>Dashboard</h1>
                    <p class="header-copy sub-heading">Overview of dealer and market visit activity.</p>
                </div>

                <div class="header-actions">
                    <q-btn no-caps icon="add" label="New Visit" class="new-visit-btn" title="Create" @click="createVisit" />
                    <q-btn :size="$q.screen.lt.md ? 'lg' : ''" flat dense no-caps icon="logout" title="Logout" class="logout-link" @click="logout" />
                </div>
            </header> -->

    <!-- FILTER / DATE RANGE STRIP -->
    <section class="filter-card">
      <div class="filter-header">
        <div class="section-title">
          <span class="section-icon">
            <q-icon :size="$q.screen.lt.md ? 'md' : ''" name="dashboard" />
          </span>
          <div>
            <h2>Visit Insights</h2>
          </div>
        </div>
        <div>
             <!-- <q-btn size="md" dense icon="add" class="refresh-btn" color="primary" :loading="false" @click="createVisit">
            New Visit
          </q-btn> -->
             <q-btn
             v-if="$q.screen.sm || $q.screen.gt.sm"
                unelevated
                no-caps
                icon="add"
                label="New Visit"
                class="primary-button"
                @click="createVisit"
              />
          <q-btn
            size="lg"
            flat
            dense
            round
            icon="refresh"
            class="refresh-btn"
            :loading="isLoading"
            @click="getVisits"
          >
            <q-tooltip>Refresh</q-tooltip>
          </q-btn>
        </div>

      </div>
      <div  v-if="$q.screen.xs || $q.screen.lt.sm" class="row">
          <q-btn                
                no-caps
                icon="add"
                label="New Visit"
                 class="primary-button col-12 q-mb-sm q-py-xs"
                @click="createVisit"
              />
        </div>

      <div v-if="$q.screen.gt.sm" class="filter-grid">
        <q-input
          v-model="filters.fromDate"
          outlined
          dense
          type="date"
          label="From Date"
          class="formField"
        />
        <q-input
          v-model="filters.toDate"
          outlined
          dense
          type="date"
          label="To Date"
          class="formField"
        />
        <q-select
          v-model="filters.region"
          outlined
          dense
          clearable
          label="Region"
          :options="regionOptions"
          class="formField"
        />
        <q-select
          v-model="filters.samName"
          outlined
          dense
          clearable
          label="Sales Account Manager"
          :options="samOptions"
          class="formField"
        />
      </div>
      <div v-else class="filter-grid">
        <q-expansion-item
          v-model="filtersExpanded"
          expand-separator
          icon="filter_list"
          label="Filters"
          class="filter-expansion"
        >
          <q-input
            v-model="filters.fromDate"
            outlined
            dense
            type="date"
            label="From Date"
            class="formField q-mt-sm"
          />
          <q-input
            v-model="filters.toDate"
            outlined
            dense
            type="date"
            label="To Date"
            class="formField q-mt-sm"
          />
          <q-select
            v-model="filters.region"
            outlined
            dense
            clearable
            label="Region"
            :options="regionOptions"
            class="formField q-mt-sm"
          />

          <q-select
            v-model="filters.samName"
            outlined
            dense
            clearable
            label="Sales Account Manager"
            :options="samOptions"
            class="formField q-mt-sm"
          />
        </q-expansion-item>
        <q-separator />
      </div>

      <div class="filter-footer">
        <div class="record-count">
          <q-icon :size="$q.screen.lt.md ? 'md' : ''" name="description" />
          <span
            >{{ filteredVisits.length }}
            {{ filteredVisits.length === 1 ? "Visit" : "Visits" }} in
            range</span
          >
        </div>

        <q-btn
          v-if="hasFilters"
          flat
          dense
          no-caps
          icon="filter_alt_off"
          label="Clear Filters"
          class="clear-filter-btn"
          @click="clearFilters"
        />
      </div>
    </section>

    <!-- STAT CARDS -->
    <section class="stats-grid">
      <article class="stat-card" v-for="card in statCards" :key="card.label">
        <div
          class="stat-icon"
          :style="{ background: card.bg, color: card.color }"
        >
          <q-icon :name="card.icon" size="22px" />
        </div>
        <div class="stat-body">
          <span class="stat-label">{{ card.label }}</span>
          <strong class="stat-value">{{ card.value }}</strong>
          <small v-if="card.hint" class="stat-hint">{{ card.hint }}</small>
        </div>
      </article>
    </section>

    <!-- CHARTS ROW -->
    <section class="charts-grid">
      <!-- Visits by Region -->
      <article class="chart-card">
        <div class="chart-card-header">
          <h3>Visits by Region</h3>
          <span class="chart-total">{{ filteredVisits.length }} total</span>
        </div>

        <div v-if="regionBreakdown.length" class="bar-list">
          <div class="bar-row" v-for="row in regionBreakdown" :key="row.label">
            <div class="bar-row-top">
              <span class="bar-label">{{ row.label }}</span>
              <span class="bar-value">{{ row.count }}</span>
            </div>
            <div class="bar-track">
              <div class="bar-fill" :style="{ width: row.pct + '%' }"></div>
            </div>
          </div>
        </div>
        <div v-else class="chart-empty">No data for this range.</div>
      </article>

      <!-- Visits by Purpose -->
      <article class="chart-card">
        <div class="chart-card-header">
          <h3>Visits by Purpose</h3>
          <span class="chart-total"
            >{{ purposeBreakdown.length }} categories</span
          >
        </div>

        <div v-if="purposeBreakdown.length" class="donut-legend">
          <div class="donut-wrap">
            <svg viewBox="0 0 42 42" class="donut-svg">
              <circle
                v-for="seg in donutSegments"
                :key="seg.label"
                cx="21"
                cy="21"
                r="15.9"
                fill="transparent"
                :stroke="seg.color"
                stroke-width="6"
                :stroke-dasharray="seg.dash"
                :stroke-dashoffset="seg.offset"
              />
            </svg>
            <div class="donut-center">
              <strong>{{ filteredVisits.length }}</strong>
              <span>Visits</span>
            </div>
          </div>

          <ul class="legend-list">
            <li v-for="row in purposeBreakdown" :key="row.label">
              <span
                class="legend-dot"
                :style="{ background: row.color }"
              ></span>
              <span class="legend-label">{{ row.label }}</span>
              <span class="legend-value">{{ row.count }}</span>
            </li>
          </ul>
        </div>
        <div v-else class="chart-empty">No data for this range.</div>
      </article>
    </section>

    <!-- RECENT VISITS -->
    <section class="list-card recent-card">
      <div class="filter-header">
        <div class="section-title">
          <span class="section-icon">
            <q-icon :size="$q.screen.lt.md ? 'md' : ''" name="history" />
          </span>
          <div>
            <h2>Recent Visits</h2>
          </div>
        </div>
        <q-btn
          flat
          dense
          no-caps
          label="View All"
          icon-right="arrow_forward"
          class="clear-filter-btn"
          @click="goToList"
        />
      </div>

      <div v-if="isLoading" class="loading-state">
        <q-spinner size="40px" color="primary" />
        <span>Loading visits...</span>
      </div>

      <div v-else-if="!recentVisits.length" class="empty-state">
        <div class="empty-icon"><q-icon name="event_busy" size="38px" /></div>
        <h3>No visits found</h3>
        <p>There are no visit records matching your filters.</p>
        <q-btn
          unelevated
          no-caps
          icon="add"
          label="Create New Visit"
          class="primary-button"
          @click="createVisit"
        />
      </div>

      <div v-else class="recent-list">
        <div
          class="recent-row"
          v-for="visit in recentVisits"
          :key="visit.id"
          @click="viewVisit(visit)"
        >
          <div class="recent-main">
            <span class="visit-id">{{ visit.id }}</span>
            <div class="dealer-info">
              <strong>{{ visit.accountName || visit.accountDealerName  || "N/A" }}</strong>
              <small
                >{{ visit.cityName || ""
                }}<span v-if="visit.regionName">
                  · {{ visit.regionName }}</span
                ></small
              >
            </div>
          </div>
          <div class="recent-meta">
            <span class="purpose-badge">{{
              visit.visitPurposeName || "N/A"
            }}</span>
            <span class="date-value">{{ formatDate(visit.visitDate) }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { v4 as uuidV4 } from "uuid";
import axios from "axios";
import apis from "@/utilities";
import api from "@/services/axios";

const PALETTE = [
  "#146b80",
  "#3f9cae",
  "#7ec4d4",
  "#c45151",
  "#e08e45",
  "#8a9a9e",
];

export default {
  name: "Dashboard",

  data() {
    return {
      isLoading: false,
      filtersExpanded: false,
      visits: [],
      regions: [],
      samNames: [],

      filters: {
        fromDate: "",
        toDate: "",
        region: "",
        samName: "",
      },
    };
  },

  computed: {
    url() {
      return this.$store.getters.url;
    },

    regionOptions() {
      return this.regions.map((e) => e.regionName).filter(Boolean);
    },

    samOptions() {
      return this.samNames.map((e) => e.samName).filter(Boolean);
    },

    hasFilters() {
      return Object.values(this.filters).some((value) => !!value);
    },

    enrichedVisits() {
      return this.visits.map((visit) => ({
        ...visit,
        samDisplayName:
          visit.samName ||
          this.samNames.find((e) => e.samName == visit.samId)?.samName ||
          "N/A",
      }));
    },

    filteredVisits() {
      let data = this.enrichedVisits;
      console.log('data: ', data);

      if (this.filters.fromDate) {
        data = data.filter(
          (item) =>
            String(item.visitDate).substring(0, 10) >= this.filters.fromDate
        );
      }
      if (this.filters.toDate) {
        data = data.filter(
          (item) =>
            String(item.visitDate).substring(0, 10) <= this.filters.toDate
        );
      }
      if (this.filters.region) {
        data = data.filter((item) => item.regionName === this.filters.region);
      }
      if (this.filters.samName) {
        data = data.filter(
          (item) => item.samDisplayName === this.filters.samName
        );
      }

      return data;
    },

    recentVisits() {
      return [...this.filteredVisits]
        .sort((a, b) => new Date(b.visitDate) - new Date(a.visitDate))
        .slice(0, 6);
    },

    statCards() {
      const total = this.filteredVisits.length;
      const uniqueDealers = new Set(
        this.filteredVisits
          .map((v) => v.accountCode || v.accountDealerName)
          .filter(Boolean)
      ).size;
      const uniqueRegions = new Set(
        this.filteredVisits.map((v) => v.regionId).filter(Boolean)
      ).size;

      const now = new Date();
      const thisMonthCount = this.filteredVisits.filter((v) => {
        const d = new Date(v.visitDate);
        return (
          d.getMonth() === now.getMonth() &&
          d.getFullYear() === now.getFullYear()
        );
      }).length;

      return [
        {
          label: "Total Visits",
          value: total,
          icon: "event_note",
          bg: "#e7f2f4",
          color: "#146b80",
        },
        {
          label: "Visits This Month",
          value: thisMonthCount,
          icon: "calendar_month",
          bg: "#eef6ee",
          color: "#3f8a4a",
        },
        {
          label: "Dealers Covered",
          value: uniqueDealers,
          icon: "store",
          bg: "#fdf3e8",
          color: "#c17a1f",
        },
        {
          label: "Regions Active",
          value: uniqueRegions,
          icon: "public",
          bg: "#f5edf8",
          color: "#7a4fa0",
        },
      ];
    },

    regionBreakdown() {
      const counts = {};
      this.filteredVisits.forEach((v) => {
        const key = v.regionName || "Unspecified";
        counts[key] = (counts[key] || 0) + 1;
      });

      const max = Math.max(1, ...Object.values(counts));

      return Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6)
        .map(([label, count]) => ({
          label,
          count,
          pct: Math.round((count / max) * 100),
        }));
    },

    purposeBreakdown() {
      const counts = {};
      this.filteredVisits.forEach((v) => {
        const key = v.visitPurposeName || "Unspecified";
        counts[key] = (counts[key] || 0) + 1;
      });

      return Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6)
        .map(([label, count], idx) => ({
          label,
          count,
          color: PALETTE[idx % PALETTE.length],
        }));
    },

    donutSegments() {
      const total =
        this.purposeBreakdown.reduce((sum, r) => sum + r.count, 0) || 1;
      const circumference = 2 * Math.PI * 15.9;
      let offsetAcc = 0;

      return this.purposeBreakdown.map((row) => {
        const fraction = row.count / total;
        const dashLength = fraction * circumference;
        const seg = {
          label: row.label,
          color: row.color,
          dash: `${dashLength} ${circumference - dashLength}`,
          offset: -offsetAcc,
        };
        offsetAcc += dashLength;
        return seg;
      });
    },
  },

  mounted() {
    console.log("this.$store.state.menus dahs", this.$store.state.menus);
    this.getVisits();
    this.getRegion();
    this.getSalesAccountManagers();

    // const visitMenu = this.$store.state.menus?.some(
    //   (m) => m.menuUrl == "/visit-form-list"
    // );

    // if (visitMenu) {
    //   this.userHaveVisitRights = true;
    // } else this.userHaveVisitRights = false;
  },

  methods: {
    async getVisits() {
      this.isLoading = true;
      this.visits = [];
      try {
        const response = await api.get(`${this.url}/${apis.GetList}`);
        this.visits = response.data.data || [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },

    async getRegion() {
      try {
        const response = await axios.get(`${this.url}/${apis.GetRegion}`);
        this.regions = response.data.data || [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        console.error(err);
      }
    },

    async getSalesAccountManagers() {
      try {
        const response = await axios.get(
          `${this.url}/${apis.GetSalesAccountManagers}`
        );
        this.samNames = response.data.data || [];
      } catch (err) {
        this.$store.dispatch("triggerUnauthorizedError", err);
        console.error(err);
      }
    },

    clearFilters() {
      this.filters = { fromDate: "", toDate: "", region: "", samName: "" };
    },

    createVisit() {
      const visitMenu = this.$store.state.menus?.some(
        (m) => m.menuUrl == "/visit-form-list"
      );
      const visitMenuId = this.$store.state.menus?.find(
        (m) => m.menuUrl == "/visit-form-list"
      )?.id;
      if (visitMenu && visitMenuId) {
        this.$router.push({
          name: "visitForm",
          params: { key: `${uuidV4()}_CREATE` },
          query: { id: visitMenuId },
        });
      } else {
        this.$q.notify({
          type: "warning",
          message: "You don't have rights to proceed this action.",
          position: "top",
        });
        return;
      }
    },

    viewVisit(visit) {
        console.log('visit: ', visit);
      const visitMenu = this.$store.state.menus?.some(
        (m) => m.menuUrl == "/visit-form-list"
      );
      const visitMenuId = this.$store.state.menus?.find(
        (m) => m.menuUrl == "/visit-form-list"
      )?.id;
      if (visitMenu && visitMenuId) {
        this.$router.push({
          name: "visitForm",
          params: { key: `${visit.srNo}_readOnly` },
          query: { id: visitMenuId },
        });
      } else {
        this.$q.notify({
          type: "warning",
          message: "You don't have rights to proceed this action.",
          position: "top",
        });
        return;
      }
    },

    goToList() {
      const visitMenu = this.$store.state.menus?.find(
        (m) => m.menuUrl == "/visit-form-list"
      );
      if(visitMenu.id){
        this.$store.commit('setMenu',visitMenu)
        this.$router.push("visit-form-list");
      }else{
         this.$q.notify({
          type: "warning",
          message: "You don't have rights to proceed this action.",
          position: "top",
        });
        return;
      }
    },

    formatDate(date) {
      if (!date) return "N/A";
      const value = String(date).substring(0, 10);
      const parts = value.split("-");
      if (parts.length !== 3) return value;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },

    logout() {
      sessionStorage.setItem("token", null);
      this.$store.commit("logOutHandler");
    },

    showDrawer() {
      if (this.$refs.refDrawer) {
        this.$refs.refDrawer.toggleDrawer();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/quasar.scss";

/* ============================================================
   BASE = MOBILE FIRST
   ============================================================ */

.brand-logo-sera {
  height: 16px;
  margin-bottom: 10px;
}

/* ================= HEADER (shared look with visit list) ================= */

.visit-header {
  min-height: 170px;
  padding: 70px 18px 24px;
  display: flex;
  align-items: flex-start;
  gap: 18px;
  color: $primary;
  position: relative;
  background: #fff;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 10px 30px rgba(13, 76, 92, 0.18);
}

.brand-mark {
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.16);
}

.header-content {
  min-width: 0;
}

h1 {
  margin: 0;
  font-size: 23px;
  line-height: 1.2;
  font-weight: 700;
}

.header-copy {
  margin: 7px 0 0;
  font-size: 12px;
  opacity: 0.85;
}

.sub-heading {
  color: $magenta !important;
}

.header-actions {
  position: absolute;
  top: 14px;
  right: 14px;
  margin: 0;
  display: flex;
  gap: 8px;
}

.new-visit-btn {
  min-height: 38px;
  font-size: 15px;
  color: #fff;
  background: $primary-gradient;
  border-radius: 8px;
}

.logout-link {
  color: $primary;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 18px;
}

/* ================= FILTER STRIP ================= */

.filter-card {
  padding: 20px 18px 15px;
  background: #fff;
  border-bottom: 1px solid #e5edef;
}

.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  color: $primary;
  background: #e7f2f4;
  border-radius: 10px;
}

.section-title h2 {
  margin: 0;
  color: $primary;
  font-size: 17px;
}

.refresh-btn {
  color: $primary;
}

.filter-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.filter-footer {
  min-height: 40px;
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.record-count {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #73858a;
  font-size: 15px;
}

.record-count .q-icon {
  color: $primary;
}

.clear-filter-btn {
  margin-left: auto;
  color: $primary;
}

/* ================= STAT CARDS ================= */

.stats-grid {
  padding: 18px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  background: #f5f8f9;
}

.stat-card {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #e3ebed;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(27, 67, 77, 0.05);
}

.stat-icon {
  width: 44px;
  height: 44px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 10px;
}

.stat-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stat-label {
  color: #87969a;
  font-size: 12px;
}

.stat-value {
  color: $primary;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.stat-hint {
  color: #a4b0b3;
  font-size: 11px;
}

/* ================= CHARTS ================= */

.charts-grid {
  padding: 0 18px 18px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  background: #f5f8f9;
}

.chart-card {
  padding: 18px;
  background: #fff;
  border: 1px solid #e3ebed;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(27, 67, 77, 0.05);
}

.chart-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.chart-card-header h3 {
  margin: 0;
  color: $primary;
  font-size: 15px;
}

.chart-total {
  color: #87969a;
  font-size: 11px;
}

.chart-empty {
  padding: 20px 0;
  color: #87969a;
  font-size: 13px;
  text-align: center;
}

/* --- bar list (region) --- */

.bar-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bar-row-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.bar-label {
  color: #35525a;
  font-size: 12px;
  font-weight: 600;
}

.bar-value {
  color: $primary;
  font-size: 12px;
  font-weight: 700;
}

.bar-track {
  width: 100%;
  height: 8px;
  background: #eef3f4;
  border-radius: 6px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: $primary-gradient;
  border-radius: 6px;
  transition: width 0.4s ease;
}

/* --- donut (purpose) --- */

.donut-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.donut-wrap {
  position: relative;
  width: 140px;
  height: 140px;
}

.donut-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.donut-center strong {
  color: $primary;
  font-size: 20px;
}

.donut-center span {
  color: #87969a;
  font-size: 11px;
}

.legend-list {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legend-list li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-dot {
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  border-radius: 50%;
}

.legend-label {
  flex: 1;
  min-width: 0;
  color: #526a70;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.legend-value {
  color: $primary;
  font-size: 12px;
  font-weight: 700;
}

/* ================= RECENT VISITS ================= */

.list-card {
  background: #fff;
  overflow: hidden;
}

.recent-card {
  padding: 20px 18px;
}

.recent-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.recent-row {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #f9fbfb;
  border: 1px solid #edf2f3;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.recent-row:hover {
  background: #f2f7f8;
}

.recent-main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.visit-id {
  color: $primary;
  font-weight: 700;
  font-size: 11px;
}

.dealer-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dealer-info strong {
  color: #35525a;
  font-size: 13px;
}

.dealer-info small {
  color: #87969a;
  font-size: 11px;
}

.recent-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.purpose-badge {
  display: inline-block;
  padding: 4px 8px;
  color: $primary;
  background: #e7f2f4;
  border-radius: 6px;
  font-size: 10px;
  white-space: nowrap;
}

.date-value {
  color: #87969a;
  font-size: 11px;
  white-space: nowrap;
}

/* ================= LOADING / EMPTY ================= */

.loading-state,
.empty-state {
  min-height: 220px;
  width: 100%;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.loading-state {
  gap: 12px;
  color: #73858a;
  font-size: 13px;
}

.empty-icon {
  width: 64px;
  height: 64px;
  margin-bottom: 14px;
  display: grid;
  place-items: center;
  color: $primary;
  background: #e7f2f4;
  border-radius: 50%;
}

.empty-state h3 {
  margin: 0;
  color: $primary;
  font-size: 16px;
}

.empty-state p {
  margin: 6px 0 18px;
  color: #819297;
  font-size: 13px;
}

.primary-button {
  color: #fff;
  background: $primary-gradient;
  border-radius: 8px;
}

/* ============================================================
   TABLET (>= 641px)
   ============================================================ */

@media (min-width: 641px) {
  .new-visit-btn {
    min-height: 38px;
    font-size: 11px;
  }

  .visit-header {
    min-height: 145px;
    padding: 30px 34px;
    border-radius: 20px 20px 0 0;
  }

  .brand-mark {
    width: 48px;
    height: 48px;
  }

  h1 {
    font-size: 28px;
  }

  .header-copy {
    font-size: 14px;
  }

  .header-actions {
    position: static;
    margin-left: auto;
  }

  .filter-card {
    padding: 25px 34px 18px;
  }

  .filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .stats-grid,
  .charts-grid {
    padding-left: 34px;
    padding-right: 34px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .recent-card {
    padding: 24px 34px;
  }
}

/* ============================================================
   DESKTOP (>= 1024px)
   ============================================================ */

@media (max-width: 1024px) {
  .filter-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .filter-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .stats-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .charts-grid {
    grid-template-columns: 1.3fr 1fr;
  }

  .donut-legend {
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }
}
</style>